import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import template from "./multi_list_facet.html";

function MultiFacet(search_model, facet, expanded, filtering, active, custom, is_control) {
    facet.data = facet.data || [];
    var thisFacet = this;
    var is_filtered = filtering ? true: false;
    var current_filter = filtering ? filtering[1] : null;
    Object.assign(this,  {
        "type": "multiple",
        "template": template,
        "caption": facet.caption,
        "name": facet.name,
        "or_group": facet.name,
        "exclusive": (facet.exclusive_name && true) || false,
        "field": facet.field,
        "exclusive_name": facet.exclusive_name,
        "icon": facet.icon,
        "colour": facet.colour || "light-sea-green",
        "custom": custom,
        "show_empty": ko.observable(facet.show_empty === true),
        "show_aggregate": facet.show_aggregate !== false,
        "domain_filter": facet.domain_filter,
        "data": ko.observableArray(facet.data.map((value) => {
            //ensure this is not already active
            // var selector = facet.name + ":" + value.key;
            // var notselector = "NOT " + selector;
            if (facet.exclusive_name) {
                var selector = facet.exclusive_name == "facet_queries" ? value.key :  facet.exclusive_name + ":" + value.key;
                var notselector = facet.exclusive_name == "facet_queries" ? "NOT " + value.key : "NOT " + (facet.exclusive_field || facet.exclusive_name) + ":" + value.key;
            } else {
                var selector = facet.name == "facet_queries" ? value.key : (facet.field || facet.name) + ":" + value.key;
                var notselector = facet.name == "facet_queries" ? "NOT " + value.key : "NOT " + (facet.field || facet.name) + ":" + value.key;
            }
            return {
                "key": value.key,
                "value": value.count > 0 ? value.count : null,
                "caption": value.caption,
                "selected": active.indexOf(selector) >= 0,
                "excluded": active.indexOf(notselector) >= 0
            };
        })),
        "sort_icon": ko.pureComputed(() => {
            var order = this.sort_order();
            if (order == 0) {
                return "fa-sort-amount-desc"
            }
            else if (order == 1) {
                return "fa-sort-amount-asc";
            }
            else if (order == 2) {
                return "fa-sort-alpha-asc";
            }
            else if (order == 3) {
                return "fa-sort-alpha-desc";
            } else {
                return "fa-sort";
           }
        }),
        "sorted_data": ko.pureComputed( () => {
            var order = this.sort_order();
            var filtered_data = this.data();
            if (this.current_filter()) {
                let toks = this.current_filter().toLowerCase().split(" ");
                if (toks.length > 0) {
                    filtered_data = filtered_data.filter((v) => { 
                        let val = (v.caption || "").toLowerCase();
                        return toks.filter((tok) => val.indexOf(tok)>=0).length == toks.length;
                        //return v.caption && v.caption.indexOf(this.current_filter()) >= 0; 
                    })
                }
            }
            if (!this.show_empty()) {
                filtered_data = filtered_data.filter((v) => { return v.value !== null });
            }
            if (order == 0) return filtered_data.sort((a, b) => {
                    return a.value < b.value ? 1 : a.value == b.value ? 0 : -1;
                });
            else if (order == 1) return filtered_data.sort((a,b) => {
                    return a.value > b.value ? 1 : a.value == b.value ? 0 : -1;
                });
            else if (order == 2) return filtered_data.sort((a,b) => {
                return a.caption > b.caption ? 1 : a.caption == b.caption ? 0 : -1;
                });
            else if (order == 3) return filtered_data.sort((a,b) => {
                return a.caption < b.caption ? 1 : a.caption == b.caption ? 0 : -1;
                });
            else return filtered_data;
        }),
        "sort_order": ko.observable(-1),
        "visible": ko.pureComputed(function() {
            return search_model.dynamic_faceting() || thisFacet.data().length > 0;
        }),
        "expandable": true,
        "is_control": ko.observable(is_control === true),
        "sortable": true,
        "toggle_sort": () => {
            this.sort_order((this.sort_order() + 1) % 4);
        },
        "filtering": ko.observable(is_filtered),
        "current_filter": ko.observable(current_filter),
        "toggle_filter": (ui, e) => {
            var span = $(e.target).parent();
            this.filtering(!this.filtering());
            if (!this.filtering()) {
                this.current_filter(null);
            } else {
                $(span).find(".title").focus();
                if (!this.expanded()) { 
                    this.expand();
                }
            }
            //e.target.focus();
            return false;
        },
        "handle_filter_key": (ui, e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
            } else if (e.keyCode == 27) {
                e.preventDefault();
                e.stopPropagation();
                this.current_filter(null);
                this.filtering(false);
            }
            return true;
        }
    });
    var f = this;
    this.selectFacet = function (data) {
        //var selector = facet.name == "facet_queries" ? data.key : ("{!tag=" + facet.name + "}" + facet.name + ":" + data.key);
        var exclusive = f.exclusive;
        if(exclusive) {
            var selector = f.exclusive_name == "facet_queries" ? data.key : (f.exclusive_field || f.exclusive_name) + ":" + data.key;
            var notselector = f.exclusive_name == "facet_queries" ? "NOT " + data.key : "NOT " + (f.exclusive_field || f.exclusive_name) + ":" + data.key;
        } else {
            var selector = f.name == "facet_queries" ? data.key : (f.field || f.name) + ":" + data.key;
            var notselector = f.name == "facet_queries" ? "NOT " + data.key : "NOT " + (f.field || f.name) + ":" + data.key;
        }
        if (data.excluded) {
            var idx = active.indexOf(notselector);
            if (idx >= 0) {
                search_model.faceting.active.splice(idx, 1);
                data.excluded = false;
                data.selected = false;
            }
        } else if (data.selected) {
            var idx = active.indexOf(selector);
            if (idx >= 0) {
                search_model.faceting.active.splice(idx, 1);
                search_model.faceting.active.push({
                    "name": f.name,
                    //no or_group for exclusions "or_group": f.name,
                    "value": data.key,
                    "valueCaption": (exclusive ? "(-) " : "[-] ") + data.caption,
                    "selector": notselector,
                    "caption": facet.caption,
                    "join": facet.join,
                    "domain_filter": facet.domain_filter
                });
                data.selected = false;
                data.excluded = true;
            }
        } else {
            search_model.faceting.active.push({
                "name": f.name,
                "or_group": f.name,
                "value": data.key,
                "valueCaption": (exclusive ? "(*) " : "[+] ") + data.caption,
                "selector": selector,
                "caption": facet.caption,
                "join": facet.join,
                "domain_filter": facet.domain_filter
            });
            data.selected = true;
            data.excluded = false;
        }
        search_model.pager.start_index(0);
        search_model.query_results();
    };
    this.expanded = ko.observable(expanded || is_control);
    this.expand = function () {
        if (this.expanded() && this.filtering()) {
            //can't collapse if filtering in progress
            return;
        }
        f.expanded(!f.expanded());
        if (f.expanded() && search_model.dynamic_faceting()) {
            search_model.query_results();
        }
    };

    // this.data.subscribe((newval) => {
    //     console.error("SEtting new data to:", this.name, newval);
    // })
}
export default MultiFacet;